import api, { setInternalCsrfToken } from './apiClient';
import type { LoginResponse, User } from '../types';

export const authApi = {
  async getCsrf(): Promise<string> {
    const { data } = await api.get<{ csrf_token: string }>('/auth/csrf');
    setInternalCsrfToken(data.csrf_token);
    return data.csrf_token;
  },
  async login(username: string, password: string): Promise<LoginResponse> {
    const { data } = await api.post('/auth/login', { username, password });
    return data;
  },
  async getMe(): Promise<User> {
    const { data } = await api.get('/auth/me');
    return data;
  },
  async refresh(): Promise<void> {
    await api.post('/auth/refresh');
  },
  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout');
    } catch {
      // Ignore; still clear local state
    }
  },
};
